/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HammerMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABSklEQVR4nL2UO04DMRCGjYAq0CM6RElBwQFWArYB5pHCmQGloliOQAcUBIlHS8cJOAHQgMLjDBwiSknDU14REiDENuzyS5a28Hz/aH7PGhOnIQA7lab1iila1toxJD1H1lcgaUFV5wuDp2m9AqyXDt45QPqAWFsspHNgbfbCv5og6zawnCHqZGFw7Jo8fXyz3i9ZOxFsgCzHg+A/nMNwA5K7GHgePuhMsAHR6kacwS+CB5LN/zDZiTVZIVko2URa0RsPkSbMMh0A1V1kPbHWDkeZkFy4f9dAOLI2ugV6miTJSEjwwHqLiOO+zg/6FDe84yK98cLdNvYLbblam/18T7aA5LlnLFd+OMne986kzbw2Z/6qcuEsRyFj6SgP0v+SrvPLyLIfA3dyxd5lY22aLMtGkfUxBh4tYMmQ9aUUuHkXsq67N1wKvEy9AVuTyMDomuypAAAAAElFTkSuQmCC)
 */
export const HammerMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M1.23 21.13a1 1 0 0 1 0-1.41l7.48-7.47c.2-.2.51-.2.7 0l2.13 2.12c.2.2.2.5 0 .7l-7.48 7.48a1 1 0 0 1-1.41 0l-1.42-1.42ZM7.76 4.93a2 2 0 0 0 0 2.83l8.1 8.1c.09.09.22.14.35.14h2.9a.5.5 0 0 0 .35-.14l3.15-3.15a2 2 0 0 0 0-2.83l-2.94-2.94.65-.66a1 1 0 0 0 0-1.4l-1.41-1.42a1 1 0 0 0-1.41 0l-.66.65-2.72-2.71a2 2 0 0 0-2.83 0L7.76 4.93ZM15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
